import { useMemo } from 'react';

import { debounce } from '@hh.ru/magritte-common-func-utils/debounce';
import { RateLimitedAction } from '@hh.ru/magritte-common-func-utils/types';

export const useDebounce: RateLimitedAction = (callback, waitMS) => {
    return useMemo(() => debounce(callback, waitMS), [waitMS, callback]);
};
